<template>
    <benefits-modal name="terms" background="#f9fafb" @open="loadTerms">
        <main class="terms">
            <loader v-if="loading" />

            <template v-else>
                <h1 class="terms-title" v-lang="'dashboard-termsTitle'"></h1>

                <rich-text class="terms-body" v-if="terms" :content="terms" />
                <p class="terms-empty" v-else v-lang="'dashboard-termsEmpty'"></p>

                <label class="terms-accept" v-if="terms && isLogged" :class="{ 'is-disabled': accepted || saving }">
                    <input type="checkbox" :checked="accepted" :disabled="accepted || saving" @change="acceptTerms" />
                    <span v-lang="'dashboard-termsAccept'"></span>
                </label>
            </template>
        </main>
    </benefits-modal>
</template>

<script>
import Api from "../../api";
import config from "../../config";
import loader from "../../shared/loader";
import BenefitsModal from "../../shared/modal-shell";
import RichText from "../../shared/rich-text";

export default {
    name: "TermsModal",
    components: { loader, BenefitsModal, RichText },
    data() {
        return {
            terms: "",
            saving: false,
            loading: true,
        };
    },
    computed: {
        isLogged() {
            return !!(this.$store.state.client && this.$store.state.client.id && this.$store.state.token);
        },
        accepted() {
            return this.$store.state.dashboard.termsAccepted;
        },
        previewTerms() {
            const program = this.$store.state.place.benefit_program || {};
            return program.terms || "";
        },
    },
    watch: {
        previewTerms(value) {
            if (config.isPreview) {
                this.terms = value;
            }
        },
    },
    methods: {
        loadTerms() {
            if (config.isPreview) {
                this.terms = this.previewTerms;
                this.loading = false;
                return;
            }

            this.loading = true;

            Api.get("place/" + window.PLACE_SLUG + "/benefits/terms")
                .then((response) => {
                    this.terms = (response.body || {}).terms || "";
                })
                .catch(() => {
                    this.terms = "";
                })
                .then(() => {
                    this.loading = false;
                });
        },
        acceptTerms() {
            if (this.accepted || this.saving) {
                return;
            }

            if (config.isPreview) {
                this.$store.commit("dashboard/setTermsAccepted", true);

                return;
            }

            this.saving = true;

            Api.post("client/accept-terms")
                .then(() => {
                    this.$store.commit("dashboard/setTermsAccepted", true);
                })
                .catch(() => {})
                .then(() => {
                    this.saving = false;
                });
        },
    },
};
</script>

<style lang="scss">
.terms {
  flex: 1 1 auto;
  width: 100%;
  max-width: 30rem;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  padding: 1.5rem 1rem 3rem;

  @media (min-width: 48rem) {
    max-width: 37.5rem;
    padding: 3rem 1rem;
  }
}

.terms-title {
  margin: 0;
  font-size: clamp(1.25rem, 6.4vw, 1.5rem);
  font-weight: 400;
  line-height: 1.3;
  color: #4d5761;
}

.terms-body {
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 1.6;
  color: #6c737f;
}

.terms-accept {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.875rem;
  line-height: 1.3;
  color: #1f2a37;
  cursor: pointer;
}

.terms-accept.is-disabled {
  cursor: default;
}

.terms-accept input {
  flex: 0 0 auto;
  width: 1.25rem;
  height: 1.25rem;
  margin: 0;
  accent-color: #2aaa4c;
  cursor: pointer;
}

.terms-accept.is-disabled input {
  cursor: default;
}

.terms-empty {
  margin: 0;
  padding: 1.5rem 0;
  font-size: 0.875rem;
  color: #6c737f;
  text-align: center;
}
</style>
